import React, { createContext, useContext, useState } from 'react';
import ToastComponent from './ToastComponent';

const ToastContext = createContext();

export const useToast = () => {
  return useContext(ToastContext);
};

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({
    visible: false,
    title: '',
    message: '',
    type: 'success',
  });

  const showToast = (title, message, type) => {
    setToast({
      visible: true,
      title,
      message,
      type
    });
  };

  const hideToast = () => {
    setToast((prev) => ({
      ...prev,
      visible: false,
    }));
  };

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      <ToastComponent
        title={toast.title}
        message={toast.message}
        type={toast.type}
        show={toast.visible}
        onClose={hideToast}
      />
    </ToastContext.Provider>
  );
};
